import { Button } from "@repo/ui/components/button"
import { Link } from "react-router"

export function NotFoundPage() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-4 p-6 text-sm">
      <h1 className="font-medium">404 — not found</h1>
      <Button render={<Link to="/" />} nativeButton={false}>
        Go home
      </Button>
    </div>
  )
}
